<style scoped>
  .current-name {
    color:#1976d2 !important;
  }
</style>
<template>
  <v-row>
    <v-dialog v-model="display" persistent max-width="400">
      <v-card>
        <v-card-title class="subtitle-1 font-weight-light">
          You are about to delete the following permission. Are you sure?
        </v-card-title>
        <v-card-text class="current-name">{{ permissionName }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            id="cancel-logout-btn"
            color="info"
            text
            @click="() => $emit('closeDialog')"
          >
            Cancel
          </v-btn>

          <v-btn
            id="confirm-logout-btn"
            color="error"
            text
            @click="deletePermission"
          >
            Yes, delete it
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
export default {
  props: {
    permission: Object,
  },
  data: () => ({
    display: false,
    loading: false,
  }),
  methods: {
    deletePermission() {
      this.loading = true;
      const url = `/v1/permissions/${this.permission._id}`;
      this.$requests.delete(url, {})
        .then(() => {
          this.$emit('success');
        })
        .catch(err => {
          this.$emit('fail', err.response.data?.message || 'Unable to delete permission...');
        })
        .then(() => {
          this.loading = false;
        });
    },
    show() {
      this.display = true;
    },
    hide() {
      this.display = false;
    },
  },
  computed: {
    permissionName() {
      if (this.permission) {
        return this.permission.name;
      }
      return '';
    },
  },
};
</script>
